var exports = {
  "OL": "x93eb46d8--d81dbb--vas-title",
  "d4": "x93eb46d8--d81dbb--star",
  "q9": "x93eb46d8--d81dbb--price",
  "M1": "x93eb46d8--d81dbb--stats",
  "me": "x93eb46d8--d81dbb--separator",
};

module.exports = exports;
